package com.milta.feature.route.domain.entity

/** Result of `POST /routes` (DOM-02) — a route created with its driver and initial deliveries. */
data class RouteCreationResult(
    val id: String,
    val status: RouteCreationStatus,
    val stopsCount: Int,
    val driverAccountId: String,
    val createdAt: String,
    /** HERE validation outcome per delivery — never a replacement address, just a status to flag
     * which stops still need a manual look. */
    val deliveries: List<DeliveryGeocodeStatus>,
    /** MIL-97 — POST /routes/me only: RoutaR actually ordered the stops. */
    val isOptimized: Boolean = false,
    /** MIL-97 — POST /routes/me only: QuotaExceeded or RoutarUnavailable, the route keeps the entered order. */
    val optimizationSkippedReason: OptimizationSkippedReason? = null,
    /** Retour 26/10 (demande 4b) — POST /routes/me only: RoutaR's km, null when not optimized. */
    val distanceKm: Double? = null,
    /** Retour 26/10 (demande 4b) — POST /routes/me only: RoutaR's duration, null when not optimized. */
    val durationMinutes: Int? = null,
)

/** One delivery's HERE validation outcome, returned right after creation/import. */
data class DeliveryGeocodeStatus(
    val deliveryId: String,
    val geocodeStatus: GeocodeStatus,
    /** Retour 26/10 (demande 3) — read for the zone name of a split; null from an older backend. */
    val address: String? = null,
)
